import { render, staticRenderFns } from "./TipModals.vue?vue&type=template&id=08187926&"
import script from "./TipModals.vue?vue&type=script&lang=js&"
export * from "./TipModals.vue?vue&type=script&lang=js&"
import style0 from "./TipModals.vue?vue&type=style&index=0&id=08187926&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports